import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForPersonComponent extends Component {
  // Defaults
  defaultColumns = [
    'id',
    'firstname',
    'lastname',
    'sections',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'firstname',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'lastname',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'sections',
      type: 'relation',
    },
    {
      property: 'positions',
      type: 'relation',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
